import { render, staticRenderFns } from "./detail-entrance-exam-schedule.vue?vue&type=template&id=580ee11d&scoped=true"
import script from "./detail-entrance-exam-schedule.vue?vue&type=script&lang=js"
export * from "./detail-entrance-exam-schedule.vue?vue&type=script&lang=js"
import style0 from "./detail-entrance-exam-schedule.vue?vue&type=style&index=0&id=580ee11d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580ee11d",
  null
  
)

export default component.exports